import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../../../../../../../../store/root-reducer';
import ViewList from './view-list';
import {
  Filters,
  PinUnpinActionType,
  SavedFilter,
} from '../../../../../../types';
import {
  deleteSavedViewRequest,
  getFilterViewListRequest,
  pinUnpinSavedFilterRequest,
  updateSavedFilterRequest,
} from '../../../../../../extra-actions';
import {
  resetUpdateSavedFilterRequest,
  resetDeleteSavedViewRequest,
  setFilters,
  resetPinUnpinSavedFilterRequest,
} from '../../../../../../prospect-slice';
import { getTeamsRequest } from '../../../../../../../settings/components/users-and-teams/extra-actions';

const mapStateToProps = (state: RootState) => ({
  filters: state.prospect.filters,
  savedFilters: state.prospect.savedFilters,
  selectedSavedView: state.prospect.selectedSavedView,
  userId: state.home.userId,

  teamsList: state.usersAndTeams.teams,
  getTeamsListRequestStatus: state.usersAndTeams.getTeamsRequest.status,

  pinUnpinSavedFilterRequestStatus:
    state.prospect.pinUnpinSavedFilterRequest.status,
  updateSavedFilterRequestStatus:
    state.prospect.updateSavedFilterRequest.status,
  updateSavedFilterRequestMessage:
    state.prospect.updateSavedFilterRequest.message,
  deleteSavedViewRequestStatus: state.prospect.deleteSavedViewRequest.status,
  deleteSavedViewRequestMessage: state.prospect.deleteSavedViewRequest.message,
});

const mapDispatchToProps = {
  sendPinUnpinSavedFilterRequest: (
    viewId: number,
    action: PinUnpinActionType,
  ) => pinUnpinSavedFilterRequest({ viewId, action }),
  sendUpdateSavedFilterRequest: (
    viewId: number,
    payload: { filterName: string; isShared: boolean; teamIds: number[] },
  ) => updateSavedFilterRequest({ viewId, payload }),
  sendDeleteSavedViewRequest: (viewId: number) =>
    deleteSavedViewRequest({ viewId }),

  sendGetTeamsListRequest: () =>
    getTeamsRequest({
      pageNum: 1,
      pageSize: 500,
    }),
  getFilterViewListRequest: () => getFilterViewListRequest({}),

  setProspectFilters: (payload: Partial<Filters>) => setFilters(payload),

  resetPinUnpinSavedFilterRequest: () => resetPinUnpinSavedFilterRequest(),
  resetUpdateSavedFilterRequest: () => resetUpdateSavedFilterRequest(),
  resetDeleteSavedViewRequest: () => resetDeleteSavedViewRequest(),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector> & {
  pinnedFilters: number;
  selectedViewId: number | null;
  handlePinUnpin: (viewId: number, action: PinUnpinActionType) => void;
  onFilterApplied: (filter: SavedFilter) => void;
  onSelectAllProspects: () => void;
};

export default connector(ViewList);
